// Environment variables access
// In production, these are injected by nginx into window.ENV
// In development, Vite loads them from .env files as import.meta.env

declare global {
  interface Window {
    ENV?: {
      AUTH0_CLIENT_ID?: string;
      AUTH0_CLASSIFIER_API_AUDIENCE?: string;
      AUTH0_DOMAIN?: string;
      BACKEND_URL?: string;
      SEGMENT_ANALYTICS_KEY?: string;
      APP_GIT_BRANCH?: string;
      APP_GIT_COMMIT?: string;
      APP_GIT_COMMIT_SHA?: string;
      ROLLBAR_ACCESS_TOKEN?: string;
      ROLLBAR_ENVIRONMENT?: string;
    };
  }
}

function getEnvVar(
  key: keyof NonNullable<Window["ENV"]>,
  viteKey: string,
): string {
  // In production, read from window.ENV (injected by nginx)
  // Check that the value exists and is not a placeholder string
  const windowEnvValue = window.ENV?.[key];
  if (windowEnvValue && !windowEnvValue.startsWith("process.env.")) {
    return windowEnvValue;
  }

  // In development, read from Vite env
  const viteEnv = import.meta.env[viteKey];
  if (viteEnv) {
    return viteEnv as string;
  }

  return "";
}

export const env = {
  AUTH0_CLIENT_ID: getEnvVar("AUTH0_CLIENT_ID", "VITE_AUTH0_CLIENT_ID"),
  AUTH0_CLASSIFIER_API_AUDIENCE: getEnvVar(
    "AUTH0_CLASSIFIER_API_AUDIENCE",
    "VITE_AUTH0_CLASSIFIER_API_AUDIENCE",
  ),
  AUTH0_DOMAIN: getEnvVar("AUTH0_DOMAIN", "VITE_AUTH0_DOMAIN"),
  BACKEND_URL: getEnvVar("BACKEND_URL", "VITE_BACKEND_URL"),
  SEGMENT_ANALYTICS_KEY: getEnvVar(
    "SEGMENT_ANALYTICS_KEY",
    "VITE_SEGMENT_ANALYTICS_KEY",
  ),
  APP_GIT_BRANCH: getEnvVar("APP_GIT_BRANCH", "VITE_APP_GIT_BRANCH"),
  APP_GIT_COMMIT: getEnvVar("APP_GIT_COMMIT", "VITE_APP_GIT_COMMIT"),
  APP_GIT_COMMIT_SHA: getEnvVar(
    "APP_GIT_COMMIT_SHA",
    "VITE_APP_GIT_COMMIT_SHA",
  ),
  ROLLBAR_ACCESS_TOKEN: getEnvVar(
    "ROLLBAR_ACCESS_TOKEN",
    "VITE_ROLLBAR_ACCESS_TOKEN",
  ),
  ROLLBAR_ENVIRONMENT: getEnvVar(
    "ROLLBAR_ENVIRONMENT",
    "VITE_ROLLBAR_ENVIRONMENT",
  ),
};
